import { render, staticRenderFns } from "./part-box.vue?vue&type=template&id=ac74c14e&scoped=true"
import script from "./part-box.vue?vue&type=script&lang=js"
export * from "./part-box.vue?vue&type=script&lang=js"
import style0 from "./part-box.vue?vue&type=style&index=0&id=ac74c14e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac74c14e",
  null
  
)

export default component.exports